import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Urls } from '../utilities/urls.component';
import { OrganisationResponseDTO } from '../models/OrganisationResponseDTO';
import { OrganisationRequestDTO } from '../models/OrganisationRequestDTO';
import { OrganisationFilterListDTO } from '../models/OrganisationFilterListDTO';

@Injectable()
export class OrganisationService {
  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  getOrganisationData() {
    var url: string = Urls.API_V2_ENDPOINT + Urls.ORGANISATION.getOrganisation;
    return this.http.get<OrganisationResponseDTO>(url, this.headers.getCommonHttpHeaders('v2_api'));
  }

  createOrganisation(request) {
    var url: string = Urls.API_ENDPOINT + Urls.ORGANISATION.createOrganisation;
    return this.http.post<OrganisationResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  updateOrganisation(request) {
    var url: string = Urls.API_ENDPOINT + Urls.ORGANISATION.updateOrganisation;
    return this.http.post<OrganisationResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  getOrganisationFilterData() {
    var url: string = Urls.API_ENDPOINT + Urls.ORGANISATION.getOrganisationFilterList;
    return this.http.get<OrganisationFilterListDTO>(url, this.headers.getCommonHttpHeaders());
  }
}
